<mat-card fxLayout="column" fxLayoutGap="16px" class="form-card">
    
 <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">

    <h4 class="titulo">
      {{ "Detalle los cambios a realizar" | translate }}
    </h4>

    <div class="full-width">
          <p class="texto-nota">
            Nota informativa:
            Al seleccionar una de las siguientes opciones
            Se habilitará la descarga de la documentación necesaria
            Una vez descargada, usted debe rellenarla con sus datos y subirla a continuación
          </p>
        </div>

  <!-- SELECTOR -->
     <mat-form-field appearance="outline" class="full-width"> 
       <mat-select placeholder="{{'¿Qué tipo de modificación quieres realizar?' | translate}}" id="selector" (selectionChange)="cambio($event)" formControlName="option">
            <mat-divider></mat-divider>
            <mat-option value="admin">{{'Cambio de administrador ->precisa documento solicitando el cambio y con los datos del adm destino + acta del cambio.' | translate}}</mat-option>
            <mat-option value="sepa">{{'Cambio de cuenta bancaria (precisa documento con el cambio SEPA)' | translate}}</mat-option>
            <mat-option value="resto">{{'Cambio correo electrónico (precisamos documento con el cambio y los puntos afectados)' | translate}}</mat-option>
            <mat-option value="potencia">{{'Cambio de potencia (precisa documento con la solicitud del cambio, origen y destino de potencia)' | translate}}</mat-option>
            <mat-option value="cif">{{'CAMBIO RESTO DATOS: CAMBIO CIF (ADJUNTAR IMAGEN CIF POR AMBAS CARAS)' | translate}}</mat-option>
            <mat-option value="resto">{{'CAMBIO RESTO DATOS: DIRECCIÓN DE FACTURACIÓN (adjuntar documento con la información)' | translate}}</mat-option>
            
        </mat-select>
      </mat-form-field>

    <!-- ADJUNTAR DOCUMENTO -->
    <mat-form-field appearance="outline" class="full-width"> 
      <mat-label>{{ "Documento adjunto" | translate }}</mat-label>
      <input matInput  [value]="fileNames.length ? fileNames.length + ' archivos seleccionados' : ''"  readonly>
      <button mat-icon-button matSuffix type="button" [disabled]="!adjuntar" (click)="fileInput.click()">
        <mat-icon> PINCHA AQUÍ PARA ADJUNTAR LOS DOCUMENTOS</mat-icon>
      </button>
      <mat-hint>PDF o DOC · Máx 5 MB</mat-hint>
    </mat-form-field>
<input type="file" multiple #fileInput hidden (change)="onFileSelected($event)" accept=".pdf,.doc,.docx"/>
 <!-- BOTONES -->
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px" class="botones">
      <button mat-raised-button class="enviar"   [disabled]="!puedeEnviar" (click)="consultar()">  {{ "ENVIAR" | translate }}  </button>
      <button mat-stroked-button class="cerrar"   (click)="close()">  {{ "CERRAR" | translate }} </button>
    </div>
 </form>
</mat-card>